module.exports = __webpack_public_path__ + "img/video_bg_mask.04846668.png";